import React, { useEffect, useState } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { BreakingNewsTicker } from './BreakingNewsTicker';

export function StickyAdminBreakingNews() {
  const [breakingNews, setBreakingNews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'breaking_news'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const posts: any[] = [];
      snapshot.forEach((doc) => {
        if (doc.data().isActive !== false) {
          posts.push({ id: doc.id, title: doc.data().title, isCustom: true, priority: doc.data().priority, url: '#' });
        }
      });
      setBreakingNews(posts);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading || breakingNews.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-[56px] lg:bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t-2 border-red-500 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
      <div className="max-w-7xl mx-auto flex w-full">
        <div className="w-full">
           <BreakingNewsTicker news={breakingNews} speed={30} delay={0} />
        </div>
      </div>
    </div>
  );
}
